'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routeMiddleware;

var _actionTypes = require('./action-types');

var _router = require('./router');

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function routeMiddleware($location, $window) {
  return function (store) {
    return function (next) {
      return function (action) {
        switch (action.type) {
          case _actionTypes.SET_LOCATION:
            action.setters.forEach(function (setter) {
              $location[setter.fn].apply($location, _toConsumableArray(setter.args || []));
            });
            action.router = (0, _router2.default)($location);
            break;
          case _actionTypes.BACK:
            $window.history.back();
            break;
        }
        return next(action);
      };
    };
  };
}

routeMiddleware.$inject = ['$location', '$window'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/ng-redux-route/lib/route-middleware.js
// module id = 917
// module chunks = 0